import React from 'react';
import { Grid } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { isNil } from 'lodash';
import classnames from 'classnames';
import { logout } from '../data/actions';

const Header = props => {
  const mainMenu = [
    {
      key: 'projects',
      label: 'Projects',
      link: '/projects',
      width: 2
    },
    {
      key: 'analysis',
      label: 'Analysis',
      link: '/analysis',
      width: 2
    },
    /* {
            key: "shared",
            label: "Shared",
            link: null,
            width: 2
        },
        {
            key: "infrastructure",
            label: "Infrastructure",
            link: null,
            width: 2
        }, */
    {
      key: 'user',
      label: 'Logout',
      link: null,
      onClick: () => {
        props.dispatch(logout());
      },
      width: 2
    }
  ];

  const elements = mainMenu.map((el, i) => {
    const classes = classnames({
      header__element: true,
      'header__element--active': el.key === props.section
    });

    return (
      <Grid.Column
        key={el.key}
        className={`${classes} header__element--${el.key}`}
        width={el.width}
      >
        {!isNil(el.link) ? ( // eslint-disable-line no-nested-ternary
          <Link className="header__link" to={el.link}>
            {el.label}
          </Link>
        ) : !isNil(el.onClick) ? ( // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <a className="header__link" href="#" onClick={el.onClick}>
            {el.label}
          </a>
        ) : (
          el.label
        )}
      </Grid.Column>
    );
  });

  return (
    <Grid.Row className="header">
      <Grid.Column className="header__element header__element--home" width={10}>
        <Link className="header__link header__link--logo" to="/">
          CubeHX
        </Link>
      </Grid.Column>
      {elements}
    </Grid.Row>
  );
};

export default connect(state => ({
  section: state.app.section
}))(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js